import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { SettingsSection } from 'pages/pga-coach/settings/settings-components'
import useSettingsStyles from 'pages/pga-coach/settings/settings.styles'
import { useStyles } from './styles'
import {
  formatDateTime,
  getStudentName,
  isHttpsUrl,
  VIDEO_PLAYER_PROPS,
} from './utils'

const RequestResponse = ({ request }) => {
  const classes = useStyles()
  const settingsClasses = useSettingsStyles()
  const { response } = request

  if (!response) return null

  return (
    <SettingsSection
      eyebrow={`Analysis sent to ${request.student?.firstName ||
        getStudentName(request.student)}`}
      subtitle={
        response.sharedAt
          ? `They were notified on ${formatDateTime(response.sharedAt)}.`
          : undefined
      }
      classes={settingsClasses}
    >
      <Box className={classes.sectionBody}>
        {response.videoUrl ? (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video
            className={classes.video}
            src={response.videoUrl}
            poster={response.thumbnailUrl || undefined}
            controls
            playsInline
            {...VIDEO_PLAYER_PROPS}
          />
        ) : null}
        {isHttpsUrl(response.onformUrl) ? (
          <Button
            variant="outlined"
            color="primary"
            component="a"
            href={response.onformUrl}
            target="_blank"
            rel="noopener noreferrer"
            classes={{ label: classes.buttonLabel }}
            style={response.videoUrl ? { marginTop: 16 } : undefined}
          >
            Open analysis in Onform
          </Button>
        ) : null}
        {response.notes ? (
          <Typography className={classes.notes} style={{ marginTop: 16 }}>
            {response.notes}
          </Typography>
        ) : null}
      </Box>
    </SettingsSection>
  )
}

RequestResponse.propTypes = {
  request: PropTypes.shape({
    student: PropTypes.object,
    response: PropTypes.shape({
      videoUrl: PropTypes.string,
      onformUrl: PropTypes.string,
      thumbnailUrl: PropTypes.string,
      notes: PropTypes.string,
      sharedAt: PropTypes.string,
    }),
  }).isRequired,
}

export default RequestResponse
